var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiGenerate = function SvgAiGenerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.25 6.938A2.437 2.437 0 0 0 16.688 4.5h1.125a2.437 2.437 0 0 0 2.437 2.438v1.125a2.437 2.437 0 0 0-2.438 2.437h-1.125a2.437 2.437 0 0 0-2.437-2.438zM6 8.25a1.5 1.5 0 0 1 1.5-1.5h5.25v-1.5H7.5a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3V12H18v3.75a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5z"
  })));
};
export default SvgAiGenerate;